import { render, staticRenderFns } from "./CannotAccessView.vue?vue&type=template&id=5008da23"
import script from "./CannotAccessView.vue?vue&type=script&lang=js"
export * from "./CannotAccessView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports